module.exports = __webpack_public_path__ + "img/logo-menicon-regular.e7b4e596.svg";